/**
 * 服务阶段标签映射（Issue #198）。
 *
 * 把后端英文枚举映射为客户可读中文。第一版与 client-app 保持一致，
 * 后续两端共享同一 token 包前请同步修改。
 */
import type { MeServiceStagesDto } from '../api/useServiceStages';

export type CustomerStage = MeServiceStagesDto['currentStage'];

export const STAGE_LABELS: Record<CustomerStage, string> = {
  lead: '初步了解',
  prospect: '意向评估',
  invited: '已邀约',
  visited: '已到访',
  assessed: '健康评估中',
  plan_proposed: '方案制定中',
  quoted: '已报价',
  signed: '已签约',
  paid: '已付款',
  manufacturing: '细胞制备中',
  infused: '已回输',
  following_up: '随访中',
  repurchased: '复购',
  referred: '已转介绍',
  lost: '已流失',
};

export function getStageLabelText(stage: CustomerStage): string {
  return STAGE_LABELS[stage] ?? stage;
}

export const STAGE_TONE: Record<CustomerStage, 'neutral' | 'progress' | 'warn' | 'good'> = {
  lead: 'neutral',
  prospect: 'neutral',
  invited: 'neutral',
  visited: 'progress',
  assessed: 'progress',
  plan_proposed: 'progress',
  quoted: 'progress',
  signed: 'good',
  paid: 'good',
  manufacturing: 'progress',
  infused: 'good',
  following_up: 'progress',
  repurchased: 'good',
  referred: 'good',
  lost: 'warn',
};
